// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "figure.dice > img {\n  width: 100%;\n}\nfigure.dice > img[data-dice-rarity='Common'],\nfigure.dice > img[data-dice-rarity='Rare'],\nfigure.dice > img[data-dice-rarity='Unique'] {\n  width: 90%;\n  margin: 14% 5% 0;\n}\n", ""]);
// Exports
module.exports = exports;
